import type { ReactNode } from 'react';
import styles from './Column.module.css';

// Base column interface
interface BaseColumnProps {
  children?: ReactNode;
  title?: string;
  isHeader?: boolean;
}

// Column Ordinal
export const ColumnOrdinal = ({ children, title, isHeader = false }: BaseColumnProps) => (
  <div className={`${styles.column} ${styles.ordinalColumn} ${isHeader ? styles.headerColumn : ''}`} title={title} role="cell">
    {children}
  </div>
);

// Column Color)
export const ColumnColor = ({ children, title, isHeader = false }: BaseColumnProps) => (
  <div className={`${styles.column} ${styles.colorColumn} ${isHeader ? styles.headerColumn : ''}`} title={title} role="cell">
    {children}
  </div>
);

// Column Title
export const ColumnTitle = ({ children, title, isHeader = false }: BaseColumnProps) => (
  <div className={`${styles.column} ${styles.titleColumn} ${isHeader ? styles.headerColumn : ''}`} title={title} role="cell">
    {children}
  </div>
);

// Column Category
export const ColumnCategory = ({ children, title, isHeader = false }: BaseColumnProps) => (
  <div className={`${styles.column} ${styles.categoryColumn} ${isHeader ? styles.headerColumn : ''}`} title={title} role="cell">
    {children}
  </div>
);

// Column Status
export const ColumnStatus = ({ children, title, isHeader = false }: BaseColumnProps) => (
  <div className={`${styles.column} ${styles.statusColumn} ${isHeader ? styles.headerColumn : ''}`} title={title} role="cell">
    {children}
  </div>
);

// Column Summary
export const ColumnSummary = ({ children, title, isHeader = false }: BaseColumnProps) => (
  <div className={`${styles.column} ${styles.summaryColumn} ${isHeader ? styles.headerColumn : ''}`} title={title} role="cell">
    {children}
  </div>
);

export const ColumnActions = ({ children, title, isHeader = false }: BaseColumnProps) => (
  <div className={`${styles.column} ${styles.summaryColumn} ${isHeader ? styles.headerColumn : ''}`} title={title} role="cell">
    {children}
  </div>
);
